import { render } from "./NavItem.vue?vue&type=template&id=f697a908&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=ts"
export * from "./NavItem.vue?vue&type=script&lang=ts"

import "./NavItem.vue?vue&type=style&index=0&id=f697a908&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f697a908"

export default script